<template>
  <div>
    <div class="container" >
      <div id="results-meta" class="results-meta">
        <div class="results-meta__wrapper u-border-color-primary-dark">
          <div class="results-meta__results-wrapper">
            <span data-id="results-count" class="results-meta__results-num u-secondary-dark u-serif u-type-42 u-type-until-bp-small-30">{{ resultsData.totalCount || 0 }}</span>
            <div class="results-meta__results-text">
              <span class="results-meta__results-label">Results <template v-if="searchTerm || (activeFilters.length > 0)">for</template></span>
              <span class="results-meta__results-term" v-if="searchTerm!==''">
              “{{ searchTerm }}”
            </span>
            </div>
          </div>
          <div class="results-meta__selected-filters">
            <ul class="results-meta__breadboxes">
              <breadbox :filter="filter" v-for="(filter, index) in activeFilters" :key="index"></breadbox>
            </ul>
            <button class="results-meta__clear-filters" @click="removeAllFilters()"  v-if="activeFilters.length > 0">
              Clear all filters
              <span class="visuallyhidden">Remove filter</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container--large">
      <ResultsListDisplayOptions v-if="showResultsListDisplayOptions"></ResultsListDisplayOptions>
    </div>
    <Calendar v-if="(isAnEventCalendar) && calendarView"></Calendar>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Breadbox from "./Breadbox";
import ResultsListDisplayOptions from "@/components/ResultsListDisplayOptions";
import Calendar from './Calendar';
import calendar from '@/mixins/calendar'

export default {
    name: 'ResultsMeta',
    mixins: [calendar],
    components: {
      Breadbox,
      ResultsListDisplayOptions,
      Calendar
    },
    data() {
      return {}
    },
    mounted() {
      this.$store.commit('updateWindowInnerWidth',  window.innerWidth)
      window.addEventListener('resize', this.updateWindowWidth)
    },
    computed: {
      ...mapGetters({
        perPage: 'getPerPage',
        perPageCalendar: 'getPerPageCalendar',
        perPageList: 'getPerPageList',
        searchTerm: 'getSearchTerm',
        resultsData: 'getResultsData',
        activeFilters: 'getActiveFilters',
        calendarView: 'getCalendarView',
        mobileBreakpoint: 'getMobileBreakpoint',
        windowInnerWidth: 'getWindowInnerWidth',
        resetToCalendarView: 'getResetToCalendarView',
      }),
      route () {
        return this.$route.name
      },
      showResultsListDisplayOptions() {
        return (this.isAnEventCalendar) && (this.windowInnerWidth > this.mobileBreakpoint)
      }
    },
    methods: {
      removeAllFilters: function () {
        this.$store.commit('updateActiveFilters', [])
      },
      updateWindowWidth() {
        this.$store.commit('updateWindowInnerWidth',  window.innerWidth)
        // console.log(this.windowInnerWidth)
        // console.log(this.mobileBreakpoint)
        // console.log(this.resetToCalendarView)
        if(this.windowInnerWidth <= this.mobileBreakpoint && this.calendarView === true) {
          this.$store.commit('updatePerPage', this.perPageList)
          this.updateCalendarView(false)
          this.$store.commit('updateResetToCalendarView', true)
        } else if (this.windowInnerWidth > this.mobileBreakpoint && this.resetToCalendarView === true) {
          this.$store.commit('updatePerPage', this.perPageCalendar)
          this.updateCalendarView(true)
          this.$store.commit('updateResetToCalendarView', false)
        }
      },
      updateCalendarView(calendarView) {
        this.$store.commit('updateCalendarView', calendarView)
        this.$emit('calendarViewChanged');
      },
    },
  }

</script>
